import { mapThemeSchemaDTOToForm } from 'Console/data/applicationDetail/themes/mappers';

import { RESET_APPLICATION_DETAIL } from '../constants';

import {
    FETCH_THEMES_IDS,
    FETCH_THEMES_IDS_DATA,
    FETCH_THEMES_IDS_ERROR,
    FETCH_THEME,
    FETCH_THEME_DATA,
    FETCH_THEME_ERROR,
    CLONE_THEME_SUCCESS,
    DELETE_THEME_SUCCESS,
    FETCH_THEME_SCHEMA,
    FETCH_THEME_SCHEMA_SUCCESS,
    FETCH_THEME_SCHEMA_ERROR,
    EDIT_THEME_SUCCESS,
} from './constants';

const initialState = {
    themeIds: {
        isLoading: false,
        hasError: false,
        data: [],
    },
    theme: {
        isLoading: false,
        hasError: false,
        data: {},
    },
    themeSchemas: {
        isLoading: false,
        hasError: false,
        data: {},
    },
};

const cloneTheme = (source, payload) => ({
    ...source,
    [`${payload.id}-copy`]: source[payload.id],
});

const cloneThemeId = (sourceArray, payload) => {
    const sourceItemIndex = sourceArray.findIndex((theme) => theme.id === payload.id);

    return [
        ...sourceArray.slice(0, sourceItemIndex + 1),
        payload,
        ...sourceArray.slice(sourceItemIndex + 1),
    ];
};

const updateThemeId = (sourceArray, payload) =>
    sourceArray.map((item) =>
        payload.themeId === item.id ? { ...item, name: payload.data.name } : item
    );

const deleteThemeById = (themes, payload) => {
    const newThemes = {
        ...themes,
    };

    delete newThemes[payload];
    return newThemes;
};

const reducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case RESET_APPLICATION_DETAIL:
            return initialState;

        case FETCH_THEMES_IDS:
            return {
                ...state,
                themeIds: {
                    ...state.themeIds,
                    hasError: false,
                    isLoading: true,
                    data: [],
                },
            };

        case FETCH_THEMES_IDS_ERROR:
            return {
                ...state,
                themeIds: {
                    ...state.themeIds,
                    hasError: true,
                    isLoading: false,
                },
            };

        case FETCH_THEMES_IDS_DATA:
            return {
                ...state,
                themeIds: {
                    ...state.themeIds,
                    hasError: false,
                    isLoading: false,
                    data: payload.data,
                },
            };

        case FETCH_THEME:
            return {
                ...state,
                theme: {
                    ...state.theme,
                    hasError: false,
                    isLoading: true,
                },
            };
        case FETCH_THEME_DATA:
            return {
                ...state,
                theme: {
                    isLoading: false,
                    hasError: false,
                    data: {
                        ...state.theme.data,
                        [payload.themeId]: payload.data,
                    },
                },
            };
        case FETCH_THEME_ERROR:
            return {
                ...state,
                theme: {
                    ...state.theme,
                    hasError: true,
                    isLoading: false,
                },
            };

        case CLONE_THEME_SUCCESS:
            return {
                ...state,
                themeIds: {
                    ...state.themeIds,
                    data: cloneThemeId(state.themeIds.data, payload),
                },
                theme: {
                    ...state.theme,
                    data: cloneTheme(state.theme.data, payload),
                    hasError: false,
                    isLoading: false,
                },
            };
        case EDIT_THEME_SUCCESS:
            return {
                ...state,
                themeIds: {
                    ...state.themeIds,
                    data: updateThemeId(state.themeIds.data, payload),
                },
            };

        case DELETE_THEME_SUCCESS:
            return {
                ...state,
                themeIds: {
                    ...state.themeIds,
                    data: state.themeIds.data.filter((themeId) => themeId.id !== payload),
                },
                theme: {
                    ...state.theme,
                    data: deleteThemeById(state.theme.data, payload),
                },
            };
        case FETCH_THEME_SCHEMA:
            return {
                ...state,
                themeSchemas: {
                    ...state.themeSchemas,
                    hasError: false,
                    isLoading: true,
                },
            };
        case FETCH_THEME_SCHEMA_SUCCESS:
            return {
                ...state,
                themeSchemas: {
                    ...state.themeSchemas,
                    data: {
                        ...state.themeSchemas.data,
                        [payload.id]: mapThemeSchemaDTOToForm(payload),
                    },
                    hasError: false,
                    isLoading: false,
                },
            };
        case FETCH_THEME_SCHEMA_ERROR:
            return {
                ...state,
                themeSchemas: {
                    ...state.themeSchemas,
                    hasError: true,
                    isLoading: false,
                },
            };
        default:
            return state;
    }
};

export default reducer;
